import request from '@/utils/request'

// 生成二维码
export function getQrCode(id) {
  return request({
    url: '/hrApi/wechat/getQrCode/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/wechat.js